import React, {Component} from 'react';
import {connect} from "react-redux";
import {getDentistDetails} from "./actions";
import Details from '../../../../components/Details/Details';
import {setDetailsFilterData, resetDetailsFilterData} from "../../../AuthWrapper/actions"


class DentistDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            option: {
                noDataText: 'Dentist has no cases.',
                hideSizePerPage: true,
                sizePerPage: 20,
            },
            dentistId:  this.props.match.params.dentistId,
            filterData: this.props.filterData
        }
    }
    componentDidMount() {
        document.title = "Dentist "+this.state.dentistId;
        this.props.getDentistDetails(this.state.dentistId);
        this.interval = setInterval(() => this.props.getDentistDetails(this.state.dentistId), 7000);
        this.setState({filterData:  this.props.filterData}, () => this.props.resetDetailsFilterData());

    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    handleGoBack(location) {
        const page = location.state.page;
        this.props.history.push({
            pathname: page,
            state: {
                filterData: location.state.filterData,
                pageNumber: location.state.pageNumber
            }
        });
        this.props.resetDetailsFilterData();

    }

    handleFilterDataChange(data) {
        this.setState({filterData: data});
        this.props.setDetailsFilterData(data);
    }

    linkToCase (row) {
        this.props.history.push({
            pathname: '/sm-admin/case-details/'+row.bookingId,
            state: {
                page: '/sm-admin/dentists/' + this.props.match.params.dentistId,
                pageName: 'Dentist Details',
                filterData: this.props.location
            }
        });
    }

    render() {
        const header = 'DENTIST ' + this.state.dentistId;
        const desc = 'The list of all cases of a dentist';
        return (
            !this.props.adminDentistDetails.loading &&  (
                <Details header={header}
                         desc={desc}
                         handleGoBack={(location) => this.handleGoBack(location)}
                         location={this.props.location}
                         isPatient={false}
                         details={this.props.adminDentistDetails.adminDentistDetails}
                         option={this.state.option}
                         linkToCase={(row) => this.linkToCase(row)}
                         setDetailsFilterData={this.props.setDetailsFilterData}
                         resetDetailsFilterData={this.props.resetDetailsFilterData}
                         filterData={this.state.filterData}
                         handleFilterDataChange={(data) => this.handleFilterDataChange(data)}
                />
            )
        )
    }
}

const mapStateToProps = state => ({
    adminDentistDetails: state.adminDentistDetails,
    filterData: state.auth.detailsFilterData,
});

const mapDispatchToProps = dispatch => {
    return {
        getDentistDetails: (id) => dispatch(getDentistDetails(id)),
        setDetailsFilterData: (data) => dispatch(setDetailsFilterData(data)),
        resetDetailsFilterData: () => dispatch(resetDetailsFilterData()),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(DentistDetails);



// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/DentistDetails/index.js